import { useResolvedDesignSystemComponent } from 'ext-ui/design-system/DesignSystemChannel'
import GeneratedLatestNavDivider, {
  NavDividerProps,
} from 'ext-ui/design-system/generated/latest/components/NavDivider/NavDivider'
import GeneratedLiveNavDivider from 'ext-ui/design-system/generated/live/components/NavDivider/NavDivider'
import React, { ReactElement } from 'react'

function renderDesignSystemNavDivider(
  Component: typeof GeneratedLiveNavDivider,
  channel: 'live' | 'latest',
  props: NavDividerProps,
): ReactElement {
  return <Component {...props} data-design-system-channel={channel} />
}

function LiveNavDivider(props: NavDividerProps): ReactElement {
  return renderDesignSystemNavDivider(GeneratedLiveNavDivider, 'live', props)
}

function LatestNavDivider(props: NavDividerProps): ReactElement {
  return renderDesignSystemNavDivider(
    GeneratedLatestNavDivider,
    'latest',
    props,
  )
}

function NavDivider(props: NavDividerProps): ReactElement {
  const ResolvedNavDivider = useResolvedDesignSystemComponent(
    LiveNavDivider,
    LatestNavDivider,
  )

  return <ResolvedNavDivider {...props} />
}

export default NavDivider
export type { NavDividerProps }
